import Api from '@/service/api';
import Select from '@/components/Form/Select/index.vue';


export default {
  name: 'LocationSelector',

  props: {
    value: Object,
    icon: String,
    placeholder: String,
    type: String,
    required: Boolean,
    title: String,
  },

  components: {
    Select,
  },

  watch: {
    country() {
      this.$emit('input', { country: this.country });
    },
  },

  methods: {
    onSearchCountries(search) {
      this.throttle(this.fetchCountries, search);
    },

    onLocationChanged() {
      this.$emit('onLocationChanged', this.value);
    },

    throttle(callback, params) {
      this.throttleCallback = callback;
      this.throttleCallbackParams = params;

      if (this.throttleLimit > 0) {
        this.throttleLimit = 500;
        return;
      }

      this.throttleLimit = 500;

      const timerId = setInterval(() => {
        this.throttleLimit -= 100;
        if (this.throttleLimit < 0) {
          clearInterval(timerId);
          this.throttleCallback(this.throttleCallbackParams);
        }
      }, 100);
    },

    async fetchCountries(search) {
      this.isError = false;

      try {
        const data = await Api.get({
          url: 'location/countries',
          queryParams: {
            lang: this.$i18n.locale,
            query: search,
          },
          preloader: false,
        });
        this.countries = data.items;
      } catch (e) {
        window.console.log(e);
      }
    },

    validate() {
      this.isError = false;

      if (!this.$refs.country.validate()) {
        this.isError = true;
      }

      return !this.isError;
    },
  },

  created() {
    this.fetchCountries();
  },

  data() {
    return {
      isError: false,
      country: null,
      countries: [],
    };
  },
};
